import React, { useState, useEffect } from 'react';
import axios from 'axios';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { RiDeleteBin6Line } from 'react-icons/ri';


const DefineLeave = ({setLoading}) => {
  const [role, setRole] = useState('');
  const [leaveType, setLeaveType] = useState('');
  const [days, setDays] = useState('');
  const [leaveDefine, setLeaveDefine] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState(['Casual Leave', 'Sick Leave', 'Maternity Leave', 'Paternity Leave']);
  const [showNewLeaveTypeInput, setShowNewLeaveTypeInput] = useState(false);
  const [newLeaveType, setNewLeaveType] = useState('');
      const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [searchTerm, setSearchTerm] = useState('');
const [selectedDefine, setSelectedDefine] = useState('');
const [showDelete, setShowDelete] = useState(false);


          const fetchLeaveDefined = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-leave-define');
      
                      if (response.ok) {
                          const data = await response.json();
                          setLeaveDefine(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch class');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }

    useEffect(() => {
        fetchLeaveDefined();
    }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!role || !leaveType || !days) {
      alert('Please fill all required fields');
      return;
    }

    const allData = {
      role: role,
      leaveType: leaveType,
      days: days,
    };

    setLoading(true);
    try {
      const response = await axios.post('https://api.kcian.in/add-leave-define', allData);

      if (response.status === 200) {

                              setResponse2({ message: `Leave Defined for ${role}.`, status: 'success' });

                              fetchLeaveDefined();
        // Clear form
        setRole('');
        setLeaveType('');
        setDays('');
        setShowNewLeaveTypeInput(false);
        setNewLeaveType('');
      } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (error) {
      console.error(error);
    } finally {
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    setLoading(false);
    }    
  };

  const handleLeaveTypeChange = (e) => {
    const value = e.target.value;
    if (value === 'add_new') {
      setShowNewLeaveTypeInput(true);
      setLeaveType('');
    } else {
      setShowNewLeaveTypeInput(false);
      setLeaveType(value);
    }
  };

  const handleAddNewLeaveType = () => {
    if (!newLeaveType.trim()) {
      alert('Please enter a leave type');
      return;
    }
    // Add new leave type and select it
    setLeaveTypes([...leaveTypes, newLeaveType.trim()]);
    setLeaveType(newLeaveType.trim());
    setShowNewLeaveTypeInput(false);
    setNewLeaveType('');
  };


  const filteredDefine = leaveDefine.filter(cls => {
  const term = searchTerm.toLowerCase();
  return (
    cls.role.toLowerCase().includes(term) ||
    cls.leave_type.toLowerCase().includes(term)
  );
});


    const handleShowDelete = (cls) => {
    setSelectedDefine(cls);
    setShowDelete(true);
  }


                const handleDelete = async (dId) => {
                    setLoading(true);
    try {
      const response = await fetch(`https://api.kcian.in/delete-leave-define/${dId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setLeaveDefine((prevData) => prevData.filter((product) => product.id !== dId));
        setShowDelete(false);
        setResponse2({ message: 'Defined Leave Removed!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting:', error);
    } finally {
                            setLoading(false);
    }
  };


  return (
    <>
      <section className="py-4">
        <div className="px-4">
          <HeadingArea message1="Leave" message2="Leave Define" />

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-5 col-12 my-2">
              <div className="profile-card">
                <p className="profile-heading">Add Leave Define</p>
                <form className="mt-4" onSubmit={handleSubmit}>
                  <div className="profile-input-area mb-4">
                    <label className="profile-badge">Role*</label>
                    <select
                      className="profile-input"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                      required
                    >
                      <option value="">Select Role</option>
                      <option value="Student">Student</option>
                      <option value="Teacher">Teacher</option>
                      <option value="Librarian">Librarian</option>
                    
                      <option value="Transport">Transport</option>
                      <option value="others">others</option>
                    </select>
                  </div>

                  <div className="profile-input-area mb-4">
                    <label className="profile-badge">Leave Type*</label>
                    <select
                      className="profile-input"
                      value={leaveType}
                      onChange={handleLeaveTypeChange}
                      required
                      disabled={showNewLeaveTypeInput}
                    >
                      <option value="">Select Type</option>
                      {leaveTypes.map((lt, idx) => (
                        <option key={idx} value={lt}>
                          {lt}
                        </option>
                      ))}
                      <option value="add_new">+ Add New Leave Type</option>
                    </select>

                    {showNewLeaveTypeInput && (
                      <div className="mt-2 d-flex">
                        <input
                          type="text"
                          className="profile-input me-2"
                          placeholder="Enter new leave type"
                          value={newLeaveType}
                          onChange={(e) => setNewLeaveType(e.target.value)}
                        />

                        <button
                        type="button"
                    className="border-0 bg-transparent cursor-pointer me-2"
                          onClick={handleAddNewLeaveType}>
                        <AiOutlinePlusCircle size={24} color='green' />
                      </button>
                      

<button
                        type="button"
                    className="border-0 bg-transparent cursor-pointer"
                          onClick={() => {
                            setShowNewLeaveTypeInput(false);
                            setNewLeaveType('');
                          }}                      >
                        <AiOutlineMinusCircle size={24} color='red' />
                      </button>

                      </div>
                    )}
                  </div>

                  <div className="profile-input-area mb-4">
                    <label className="profile-badge">Days*</label>
                    <input
                      type="number"
                      className="profile-input"
                      value={days}
                      onChange={(e) => setDays(e.target.value)}
                      required
                      min="1"
                    />
                  </div>

                  <div className="text-center mt-3">
                    <button className="profile-btn">
                      <FaCheck /> SAVE
                    </button>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100">
              <div className="profile-card">
                <div className="d-md-flex d-sm-flex justify-content-between mb-2">
                  <span className="profile-heading align-content-center">
                    Leave Define List
                  </span>

                  <div className="profile-input-area ms-auto col-lg-3 border-0">
                    <input
                      type="text"
                      name="search"
                      className="profile-input border-bottom rounded-0"
                      placeholder="Search..."
                        value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}

                    />
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="w-100">
                    <thead className="account-thead">
                      <tr>
                        <th className="rounded-start-4">S No</th>
                        <th>Role</th>
                        <th>Leave Type</th>
                        <th>Days</th>
                        <th className="rounded-end-4">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDefine.length === 0 ? (
                        <tr className="account-tr text-center">
                          <td colSpan="5">
                            No leaves defined yet.
                          </td>
                        </tr>
                      ) : (
                        filteredDefine.map((leave, idx) => (
                          <tr className="account-tr" key={idx}>
                            <td>{idx + 1}</td>
                            <td>{leave.role}</td>
                            <td>{leave.leave_type}</td>
                            <td>{leave.days}/ Month</td>
                            <td>
<RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleShowDelete(leave)} />                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Define!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
                        <th className='rounded-start-4'>Role</th>
                        <th>Leave Type</th>
                        <th className='rounded-end-4'>Days</th>
                        </thead>

<tr className='account-tr'>
                            <td>{selectedDefine.role}</td>
                            <td>{selectedDefine.leave_type}</td>
                            <td>{selectedDefine.days}/ Month</td>
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Defined Leave will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedDefine.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  );
};

export default DefineLeave;
